module.exports = __webpack_public_path__ + "static/media/20170806_31day_1578AT.13cf925f.jpg";